import type { KeyboardEvent } from 'react';

/** ⌘/Ctrl+Enter submits the enclosing `<form>` — mirrors the per-card
 *  disposition shortcut so bulk approve/reject/needs-review dialogs can be
 *  confirmed from the keyboard. Plain Enter keeps its default (a newline in
 *  a textarea). Attach as `onKeyDown` to a textarea inside a `<form>` whose
 *  `onSubmit` does the validation + action. */
export function submitFormOnCmdEnter(e: KeyboardEvent<HTMLTextAreaElement>): void {
  if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
    e.preventDefault();
    e.currentTarget.form?.requestSubmit();
  }
}
